import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../core/config/core.httpclient-utils';

@Injectable()
export class FrsPackageService {
  private baseUrl = '/api/frspackage/';

  constructor(private http: HttpClient) {}

  fetch(project: string): Promise<any> {
    return doGetPromise(this.http, `${this.baseUrl}${project}/package`);
  }

  save(data: any): Promise<any> {
    return this.http.post(this.baseUrl, data).toPromise();
  }

  delete(id: string): Promise<any> {
    return this.http.delete(`${this.baseUrl}${id}`).toPromise();
  }
}